import axios from "axios";
import { API_URL } from "@/config";

export default {
  namespaced: true,

  actions: {
    async getMany(_, criteria) {
      const response = await axios.get(`${API_URL}/cooks`, { params: criteria });

      if (!response.data || typeof response.data !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async getOne(_, cookId) {
      const response = await axios.get(`${API_URL}/cooks/${cookId}`);

      if (!response.data || typeof response.data !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async create(_, cookData) {
      const response = await axios.post(`${API_URL}/cooks`, cookData);

      if (response.status !== 201 || !response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async update(_, { cookId, cookData }) {
      const response = await axios.put(`${API_URL}/cooks/${cookId}`, cookData);

      if (response.status !== 200 || !response.data) {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async delete(_, cookId) {
      const response = await axios.delete(`${API_URL}/cooks/${cookId}`);

      if (response.status !== 200 || !response.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },

    async activate(_, cookId) {
      const res = await axios.post(`${API_URL}/cooks/${cookId}/activate`);

      if (res.status !== 200 || !res.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },

    async deactivate(_, cookId) {
      const res = await axios.post(`${API_URL}/cooks/${cookId}/deactivate`);

      if (res.status !== 200 || !res.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },
  },
};
